import { render, staticRenderFns } from "./ProductData.vue?vue&type=template&id=5e0ad2c5"
import script from "./ProductData.vue?vue&type=script&lang=js"
export * from "./ProductData.vue?vue&type=script&lang=js"
import style0 from "./ProductData.vue?vue&type=style&index=0&id=5e0ad2c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports